function decodeHtmlEntities(str: string): string {
  return str
    .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
}

function normalizeForSearch(str: string): string {
  const decoded = decodeHtmlEntities(str);
  return decoded
    .toLowerCase()
    .replace(/[\s\-_()\[\]{}.,:;!?']/g, '')
    .trim();
}

function isPrimitiveMatch(
  value: string | number | boolean,
  term: string,
): boolean {
  return normalizeForSearch(value.toString()).includes(
    normalizeForSearch(term),
  );
}

function arrayContainsTerm(
  arr: any[],
  term: string,
  fields?: string[],
): boolean {
  return arr.some((item) => deepContainsTerm(item, term, fields));
}

function objectFieldContainsTerm(
  obj: any,
  term: string,
  fields: string[],
): boolean {
  return fields.some((field) => {
    const keys = field.split('.');
    // Collect all leaf values at the end of the path, even through arrays
    function collectLeafPrimitives(current: any, idx: number): any[] {
      if (current == null) return [];
      if (idx >= keys.length) {
        if (
          typeof current === 'string' ||
          typeof current === 'number' ||
          typeof current === 'boolean'
        ) {
          return [current];
        }
        return [];
      }
      if (Array.isArray(current)) {
        return current.flatMap((item) => collectLeafPrimitives(item, idx));
      }
      return collectLeafPrimitives(current[keys[idx]], idx + 1);
    }
    const values = collectLeafPrimitives(obj, 0);
    if (!values.length) return false;
    return values.some((value) => deepContainsTerm(value, term));
  });
}

function objectValuesContainTerm(obj: any, term: string): boolean {
  return Object.values(obj).some((value) => deepContainsTerm(value, term));
}

function deepContainsTerm(obj: any, term: string, fields?: string[]): boolean {
  if (!term) {
    return true;
  }
  const search = normalizeForSearch(term);
  if (obj == null) {
    return false;
  }
  if (
    typeof obj === 'string' ||
    typeof obj === 'number' ||
    typeof obj === 'boolean'
  ) {
    return isPrimitiveMatch(obj, term);
  }
  if (Array.isArray(obj)) {
    return arrayContainsTerm(obj, term, fields);
  }
  if (typeof obj === 'object') {
    if (fields && fields.length > 0) {
      return objectFieldContainsTerm(obj, term, fields);
    }
    return objectValuesContainTerm(obj, term);
  }
  return false;
}

export function objectContainsTerm(
  obj: unknown,
  term: string,
  fields?: string[],
): boolean {
  return deepContainsTerm(obj, term, fields);
}
